export const storagePrefix: string = 'ls-v2-4__';
export const LS_USER_ID_KEY = 'ls-user-id';

export const ignoreLocalStorageItem = [
  'status2fa',
  'auth-token',
  'active-team',
  'loglevel:webpack-dev-server',
  'language',
  LS_USER_ID_KEY,
];
